<template>
  <div class="sideBarContainer">
    <div class="popWrapper">
      <canvas id="popCanvas" ref="popCanvas"></canvas>
    </div>
    <div class="BarItem" v-if="live.qrCodeUrl" @click="openQrcode">
      <img src="@assets/icons/icon_qrcode.png" />
      <span>{{ $i18n('share', '分享') }}</span>
    </div>
    <van-badge v-if="showPrizeBtn" :content="noReceivedCount">
      <div class="BarItem" @click="openPrize">
        <img src="@assets/icons/icon_prize.png" />
        <span>{{ $i18n('prize', '奖品') }}</span>
      </div>
    </van-badge>
    <div class="BarItem" v-if="live.goldLotterySwitch" @click="openDraw">
      <img src="@assets/icons/icon_draw.png" />
      <span>{{ $i18n('joinLottery', '抽奖') }}</span>
    </div>
    <div class="BarItem" v-if="showGiftBtn" @click="openGift">
      <img src="@assets/icons/icon_v_gift.png" />
      <span>{{ $i18n('gift', '礼物') }}</span>
    </div>
    <div class="BarItem" v-if="showRechargeBtn" @click="openRecharge">
      <img src="@assets/icons/icon_recharge.png" />
      <span>{{ $i18n('recharge', '充值') }}</span>
    </div>
    <van-popup
        v-model="showPrize"
        position="bottom"
        round
        :style="{
        width: '100%',
        minHeight: '40%',
        paddingTop: '20px',
        background: '#f2f2f2',
      }"
    >
      <div class="prizeItem" v-for="(item, index) in prizeResult" :key="index">
        <div class="mainWrap">
          <img :src="item.dlrLotteryPrize.picUrl" />
          <div class="infoWrap">
            <span class="title">{{ item.dlrLotteryPrize.prizeName }}</span>
          </div>
        </div>
        <div class="slaveWrap">
          <div class="left">
            <span class="prizeName">{{ $i18n('deductCoins', '扣除金币') }}：{{ item.deductGoldCoin }}{{ $i18n('countUnit', '个') }}</span>
            <span>{{ $i18n('winTime', '中奖时间') }} {{ item.createTime }}</span>
          </div>
        </div>
        <div
            class="statusWrap"
            :style="{ backgroundImage: 'url(' + statusBg(item.isReceived) + ')' }"
        ></div>
        <div class="btWrap" v-show="!item.isReceived" @click="openReceiveQrCode(item.id)">{{ $i18n('receive', '领取') }}</div>
      </div>
      <NoData v-if="prizeResult.length == 0"></NoData>
    </van-popup>
    <van-popup v-model="showDraw" round class="draw-popup">
      <LuckyWheel
          ref="wheel"
          :custom-prizes="prizeList"
          :initial-coins="userInfo.nowMoney||live.gameYue"
          :spin-cost="goldThreshold"
          :enable-backend-control="true"
          @request-prize="handleRequestPrize"
          @spin-result="handleSpinResult"
      />
    </van-popup>
    <van-popup v-model="showWriteOffQrCode" round class="lotteryContainer">
      <img class="qrCodeImg" :src="writeOffQrCodeUrl" />
      <div class="tip">{{ $i18n('verificationCode', '核销码') }}</div>
    </van-popup>

    <!-- ═══════════════════════════════════════════════
         礼物弹窗：纯原生实现
         遮罩 + 底部面板 + 原生页签（左右滑切页签）+ 面板内纵向滚动
         ═══════════════════════════════════════════════ -->
    <transition name="nativeFade">
      <div class="nativePopupMask" v-if="showGift" @click.self="showGift = false">
        <transition name="nativeSlideUp" appear>
          <div class="nativeGiftPopup">

            <!-- 页签头：原生实现，点击切换 -->
            <div class="nativeTabsHead">
              <div class="nativeTab"
                   v-for="(tab, i) in giftTabsDef"
                   :key="i"
                   :class="{ active: giftTab === i }"
                   @click="switchGiftTab(i)">
                {{ tab.title }}
              </div>
              <div class="nativeTabLine" :style="{ transform: 'translateX(' + giftTab * 100 + '%)' }"></div>
            </div>

            <!-- 内容区：横向 scroll-snap 轨道，左右滑 = 切页签 -->
            <div class="nativeTabsTrack"
                 ref="giftTrack"
                 @scroll.passive="onTrackScroll"
                 @touchstart="onTrackTouchStart"
                 @touchend="onTrackTouchEnd">
              <!-- 面板1：礼物，纵向滚动 -->
              <div class="nativePanel">
                <div class="giftListContainer">
                  <div class="giftListWrap">
                    <div class="giftItem"
                         v-for="item in giftList"
                         :key="item.id"
                         @click="sendGiftFun(item)">
                      <span v-if="isEffectGift(item)" class="giftIcon">{{ effectIcon(item) }}</span>
                      <img v-else :src="item.coverUrl" alt />
                      <div class="giftName">{{ item.giftName }}</div>
                      <div class="price-wrap">
                        <img class="gold-icon" src="@assets/icons/icon_gold_coin.png" alt="金币" />
                        <span class="price-num">{{ item.goldCoin }}</span>
                      </div>
                      <div class="sendGiftBt">{{ $i18n('send', '发送') }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 面板2：霸屏礼物 -->
              <div class="nativePanel">
                <div class="giftListContainer">
                  <div class="giftListWrap">
                    <div class="giftItem"
                         v-for="item in blastGiftList"
                         :key="item.code"
                         @click="sendBlastFun(item)">
                      <img :src="item.picUrl" alt />
                      <div class="giftName">{{ item.desc }}</div>
                      <div class="price-wrap">
                        <img class="gold-icon" src="@assets/icons/icon_gold_coin.png" alt="金币" />
                        <span class="price-num">{{ item.price }}</span>
                      </div>
                      <div class="sendGiftBt">{{ $i18n('burst', '霸屏') }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 面板3：文字霸屏 -->
              <div class="nativePanel">
                <div class="blastFormContainer">
                  <textarea class="nativeTextarea"
                            v-model="textBlastForm.content"
                            rows="3"
                            maxlength="50"
                            :placeholder="$i18n('enterBlastText', '输入霸屏祝福语（50字以内）')"></textarea>
                  <div class="nativeWordLimit">{{ (textBlastForm.content || '').length }} / 50</div>
                  <div class="blastBtnWrap">
                    <button class="nativeBtn ghost"
                            :disabled="genBlessingLoading"
                            @click="onGenBlessing">{{ $i18n('genBlessing', '生成祝福语') }}</button>
                    <button class="nativeBtn solid"
                            @click="sendTextBlastFun">
                      {{ $i18n('send', '发送') }}（{{ textBlastPrice }}{{ $i18n('goldCoinUnit', '金币') }}）
                    </button>
                  </div>
                </div>
              </div>

              <!-- 面板4：照片霸屏 -->
              <div class="nativePanel">
                <div class="blastFormContainer">
                  <div class="nativeUploadGrid">
                    <!-- 已选照片 -->
                    <div class="nativeUploadCell" v-for="(f, i) in photoBlastList" :key="i">
                      <img :src="f.previewUrl || f.url" />
                      <div class="nativeUploadStatus" v-if="f.status === 'uploading'">
                        {{ $i18n('uploading', '上传中...') }}
                      </div>
                      <div class="nativeUploadStatus fail" v-else-if="f.status === 'failed'">
                        {{ $i18n('uploadFailed', '上传失败') }}
                      </div>
                      <div class="nativeUploadDel" @click.stop="removePhoto(i)">×</div>
                    </div>
                    <!-- 添加按钮（未满6张） -->
                    <div class="nativeUploadCell add"
                         v-if="photoBlastList.length < 6"
                         @click="pickPhoto">
                      +
                    </div>
                  </div>
                  <div class="blastBtnWrap">
                    <span class="blastPriceTip">{{ $i18n('photoBlastPriceTip', '88金币/张') }}</span>
                    <button class="nativeBtn solid"
                            @click="sendPhotoBlastFun">
                      {{ $i18n('send', '发送') }}（{{ photoBlastTotal }}{{ $i18n('goldCoinUnit', '金币') }}）
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <!-- 隐藏的文件选择器（原生 input） -->
    <input type="file"
           ref="photoInput"
           accept="image/*"
           multiple
           style="display: none"
           @change="onPhotoInputChange" />

    <QrCodePopup v-if="live.qrCodeUrl"
                 :qrCodeImage="live.qrCodeUrl"
                 :show="showQrcode"
                 @close="showQrcode=false"
    />
    <RechargePopup :show.sync="showRecharge"/>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import JumpBubble from "@libs/JumpBubble";
import {Toast} from "vant";
import {mapGetters, mapState} from "vuex";
import NoData from "@components/NoData";
import QrCodePopup from "@/views/home/model/popup/QrCodePopup";
import RechargePopup from "@/views/home/model/popup/RechargePopup.vue";
import LuckyWheel from "@/components/LuckyWheel";
import {_code} from "@utils/constant";
import i18nMixin from "@/libs/i18nMixin";
import { compressImage } from "@utils/index";

/* effect 礼物 icon 兜底表（code → emoji），库 icon 优先 */
const EFFECT_ICON_FALLBACK = {
  heart: '❤️',         hongbao: '🧧',       rose: '🌹',
  champagne: '🥂',     cake: '🎂',          ring: '💍',
  wishStar: '🌟',      cherryBlossom: '🌸', butterfly: '🦋',
  loveLetter: '💌',
  hotAirBalloon: '🎈', firework: '🎆',      diamondRain: '💎',
  crown: '👑',         sportsCar: '🏎️',
  lemon: '🍋',         suona: '🎺',         bulb: '💡',
  pigTrotter: '🐷',    garlic: '🧄',        six666: '🔥',
}

/* 面板定义：左右滑动顺序 = 数组顺序 */
const GIFT_TABS_DEF = [
  { key: 'gift',  title: '' },  // title 在 computed 里拼 i18n
  { key: 'blast', title: '' },
  { key: 'text',  title: '' },
  { key: 'photo', title: '' },
]

export default {
  name: "GiftPop",
  mixins: [i18nMixin],
  components: {
    RechargePopup,
    QrCodePopup,
    NoData,
    LuckyWheel,
  },
  data: function () {
    return {
      showRecharge: false,
      showQrcode: false,
      showWriteOffQrCode: false,
      showPrize: false,
      showGift: false,
      showDraw: false,
      roomName: "",
      writeOffQrCodeUrl: "",
      giftList: [],
      prizeResult: [],
      noReceivedCount: 0,
      drawIdx: -1,
      goldThreshold: 0,
      prizeList: [],
      // ====== 原生页签状态 ======
      giftTab: 0,                       // 当前页签索引
      tabsScrolling: false,             // 轨道是否正在惯性滑动中（防抖）
      trackTouchStartX: 0,              // 手势起点X
      trackTouchStartY: 0,              // 手势起点Y
      // ====== 霸屏礼物 / 表单状态（原样保留） ======
      blastGiftList: [],
      textBlastPrice: 66,
      photoBlastPrice: 88,
      textBlastForm: { content: "" },
      photoBlastList: [],
      genBlessingLoading: false,
      defaultBlastIcon: "https://qiniu.dljok.com/static/icon/h5/icon_gift.png"
    };
  },
  computed: {
    ...mapGetters(["live", "userInfo", "appConfig"]),
    /* 页签标题（i18n 放 computed，语言切换能响应） */
    giftTabsDef() {
      return [
        { key: 'gift',  title: this.$i18n('gift', '礼物') },
        { key: 'blast', title: this.$i18n('blastGift', '霸屏礼物') },
        { key: 'text',  title: this.$i18n('textBlast', '文字霸屏') },
        { key: 'photo', title: this.$i18n('photoBlast', '照片霸屏') },
      ]
    },
    photoBlastCount() {
      return this.photoBlastList.filter(f => f.status === 'done' && f.url).length;
    },
    photoBlastTotal() {
      return this.photoBlastPrice * this.photoBlastCount;
    },
    showPrizeBtn() {
      return true;
      // return ['meeting_sales','wedding','business_activity','uyghur_wedding','birthday','company_meeting','graduation_banquet'].includes(this.live.liveTypeCode);
    },
    showGiftBtn() {
      return ['meeting_sales','wedding','memorial','chat_group','business_activity','uyghur_wedding','birthday','company_meeting','graduation_banquet'].includes(this.live.liveTypeCode);
    },
    showRechargeBtn() {
      return ['meeting_sales','wedding','memorial','chat_group','business_activity','uyghur_wedding','birthday','company_meeting','graduation_banquet'].includes(this.live.liveTypeCode);
    }
  },
  watch: {
    showGift(val) {
      this.$Bus.$emit("triggerGift", val);
      // ★ 弹窗每次打开：v-if 销毁过轨道 DOM，scrollLeft 已归零，
      //   必须把轨道强制拨回当前 giftTab 对应的面板，否则页签和内容错位
      if (val) {
        this.$nextTick(() => {
          this.syncTrackToTab(this.giftTab);
        });
      }
    },
    showDraw(val) {
      this.$Bus.$emit("triggerGift", val);
    },
    showPrize(val) {
      this.$Bus.$emit("triggerGift", val);
    }
  },
  created() {
    this.getGiftList();
    this.getPrizeData();
    this.getBlastGiftList();
    this.$store.dispatch("live/getLiveInfo", this.live.id).then(res => {
      this.goldThreshold = res.goldThreshold;
    });
  },
  mounted() {
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);
    this.initPop();
    this.$Bus.$on("openGift", (msg) => {
      this.showGift = true
    });
    this.$Bus.$on("noticeWinner", (msg) => {
      this.getPrizeData();
    });
  },
  beforeDestroy() {
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
    this.$Bus.$off("openGift");
    this.$Bus.$off("noticeWinner");
  },
  methods: {
    /** ★ 打开弹窗时用：直接定位，无平滑动画（开窗瞬间内容就在正确面板） */
    syncTrackToTab(i) {
      const track = this.$refs.giftTrack;
      if (!track) return;
      track.scrollLeft = i * track.clientWidth;
    },
    isEffectGift(item) {
      return item.giftType === 'effect'
    },
    effectIcon(item) {
      return item.icon || EFFECT_ICON_FALLBACK[item.code] || '✨'
    },

    /* ═══════════ 原生页签：切换 + 手势 ═══════════ */

    /** 点击页签头切换 */
    switchGiftTab(i) {
      this.giftTab = i
      this.scrollToTab(i)
    },
    /** 轨道滚到指定面板（smooth 平滑） */
    scrollToTab(i) {
      const track = this.$refs.giftTrack
      if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' })
    },
    /** 轨道滚动 → 同步页签高亮（scroll 事件驱动） */
    onTrackScroll() {
      if (this.tabsScrolling) return
      const track = this.$refs.giftTrack
      if (!track) return
      this.tabsScrolling = true
      // scroll 高频触发，rAF 节流
      requestAnimationFrame(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth)
        if (idx !== this.giftTab && idx >= 0 && idx < 4) {
          this.giftTab = idx
        }
        this.tabsScrolling = false
      })
    },
    /** 手势起点记录 */
    onTrackTouchStart(e) {
      const t = e.touches[0]
      this.trackTouchStartX = t.clientX
      this.trackTouchStartY = t.clientY
    },
    /**
     * 手势结束：横竖位移比 > 1 且横向位移 > 30px 时判定为"切页签"意图，
     * scroll-snap 自己会把轨道吸到最近面板，这里只兜底极端情况
     */
    onTrackTouchEnd(e) {
      const t = e.changedTouches[0]
      const dx = t.clientX - this.trackTouchStartX
      const dy = t.clientY - this.trackTouchStartY
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        // 横向手势：scroll-snap 吸附会触发 scroll → onTrackScroll 同步页签
      }
      // 纵向手势：不处理，浏览器自己滚面板内容
    },

    handleSocketMessage(msg) {
      switch (msg.msgType) {
        case _code.WRITE_OFF:
          this.writeOff();
          break;
        case _code.WINNER_NOTICE:
          this.getPrizeData();
          break;
      }
    },
    openQrcode() {
      this.showQrcode = true;
    },
    openRecharge() {
      this.showRecharge = true;
    },
    openReceiveQrCode(id) {
      this.showPrize = false;
      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$i18n('loading', '加载中...'),
      });
      this.$http
          .get("/api/dlrLotteryResult/getVerifyCode", {
            params: { resultId: id },
          })
          .then((res) => {
            this.writeOffQrCodeUrl = res.data;
            this.showWriteOffQrCode = true;
          })
          .finally(() => {
            toast.clear();
          });
    },
    statusBg(isReceived) {
      if (isReceived) {
        return require("@/assets/icons/icon_received.png");
      } else {
        return require("@/assets/icons/icon_no_receive.png");
      }
    },
    async writeOff() {
      await this.getPrizeData();
      this.$toast(this.$i18n('verificationSuccess', '核销成功！'));
      this.showWriteOffQrCode = false;
    },
    async openPrize() {
      await this.getPrizeData();
      this.showPrize = true;
    },
    async getPrizeData() {
      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$i18n('loading', '加载中...'),
      });
      await this.$http
          .get("/api/dlrLotteryResult/getMyLotteryResult", {
            params: { liveId: this.live.id } })
          .then((res) => {
            this.prizeResult = res.data;
            this.noReceivedCount = res.data.filter(item => item.isReceived === false).length;
          })
          .finally(() => { toast.clear(); });
    },
    async openDraw() {
      const toast = Toast.loading({
        duration: 0, forbidClick: true,
        message: this.$i18n('loading', '加载中...'),
      });
      const getRandomColor = () => {
        const randomHex = () => Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
        return `#${randomHex()}${randomHex()}${randomHex()}`;
      };
      await this.$http
          .get("/api/dlrLotteryPrize/getPrizeList", {
            params: { liveId: this.live.id, drawMethod: 0 } })
          .then((res) => {
            this.prizeList = res.data.map((item) => {
              return {
                prizeName: item.prizeName,
                picUrl: item.picUrl,
                color: getRandomColor(),
                winningProbability: item.winningProbability,
                productValue: item.productValue,
                isWin: parseInt(item.productValue) > 0
              }
            })
            this.showDraw = true;
          })
          .finally(() => { toast.clear(); });
    },
    handleRequestPrize(callback) {
      this.$http
          .get("/api/lottery/draw",
              { params: { liveId: this.live.id } })
          .then((res) => {
            this.drawIdx = res.data;
            callback.onSuccess(this.drawIdx);
          })
          .catch((err) => {
            console.error(err);
            this.showDraw = false;
            this.$toast.fail({ message: this.$i18n('insufficientCoins', '金币不足，请稍等...') });
            this.$Bus.$emit("triggerOpenRecharge");
          });
    },
    handleSpinResult(result) {
      console.log('result:', result);
    },
    handleNoMoney() {
      this.showDraw = false;
      this.$toast.fail({ message: this.$i18n('insufficientCoins', '金币不足，请稍等...') });
      this.$Bus.$emit("triggerOpenRecharge");
    },
    initPop() {
      let popCanvas = this.$refs.popCanvas;
      popCanvas.width = 100;
      popCanvas.height = 300;
      const bubble = new JumpBubble(popCanvas);
      bubble.config.cavWidth = 50;
      let list = [
        "https://qiniu.dljok.com/static/icon/h5/icon_blue_star.png",
        "https://qiniu.dljok.com/static/icon/h5/icon_wish.png",
        "https://qiniu.dljok.com/static/icon/h5/icon_love.png"
      ];
      setInterval(() => {
        list.forEach((item) => { bubble.create(item); });
      }, 250);
    },

    /* ═══════════ 数据获取 ═══════════ */

    getBlastGiftList() {
      this.$http
          .get("/gift/getBlastGiftList",{ params: { liveId: this.live.id } })
          .then((res) => {
            this.blastGiftList = (res.data || []).map(item => {
              if (typeof item === 'string') {
                return { code: item, desc: item, price: 0, picUrl: this.defaultBlastIcon };
              }
              return {
                code: item.code || item.name || item.giftCode,
                desc: item.desc || item.description || item.name,
                price: item.price || item.goldCoin || 0,
                picUrl: item.picUrl || item.icon || this.defaultBlastIcon,
              };
            });
          })
          .catch((err) => {
            console.error("霸屏礼物列表加载失败：", err.message);
          });
    },

    onGenBlessing() {
      this.genBlessingLoading = true;
      this.$http
          .get("/gift/genBlessing", { params: { liveId: this.live.id } })
          .then((res) => { this.textBlastForm.content = res.data; })
          .catch((err) => {
            this.$toast.fail(err.message || this.$i18n('genBlessingFail', '生成失败，请重试'));
          })
          .finally(() => { this.genBlessingLoading = false; });
    },

    /* ═══════════ 照片霸屏：原生 input[type=file] ═══════════ */

    /** 点 + 弹出选图 */
    pickPhoto() {
      this.$refs.photoInput.click()
    },
    /** 原生 input change：入队 + 逐张上传 */
    onPhotoInputChange(e) {
      const files = Array.from(e.target.files || [])
      e.target.value = ''   // 清空，允许重复选同一张
      files.slice(0, 6 - this.photoBlastList.length).forEach(f => {
        const item = {
          file: f,
          previewUrl: URL.createObjectURL(f),
          url: '',
          status: 'uploading',
        }
        this.photoBlastList.push(item)
        this.uploadPhoto(item)
      })
    },
    /** 删除一张（含上传中） */
    removePhoto(i) {
      const item = this.photoBlastList[i]
      if (item && item.previewUrl) URL.revokeObjectURL(item.previewUrl)
      this.photoBlastList.splice(i, 1)
    },
    async uploadPhoto(item) {
      try {
        let imgFile = item.file;
        try {
          imgFile = await compressImage(imgFile, { maxSizeKB: 100 });
        } catch (e) {
          console.warn("图片压缩失败，使用原图上传：", e);
        }
        const formData = new FormData();
        formData.append("file", imgFile, imgFile.name);
        formData.append("dir", "live/" + this.live.id);
        const res = await this.$http.post(
            "/api/upload/uploadFile",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
              transformRequest: [(data) => data],
            }
        );
        item.status = "done";
        item.url = res.data;
      } catch (e) {
        item.status = "failed";
      }
    },

    /* ═══════════ 四类发送 ═══════════ */

    sendGiftFun(item) {
      const param = { giftId: item.id, liveId: this.live.id };
      const toast = Toast.loading({
        duration: 0, forbidClick: true,
        message: this.$i18n('sendingGift', '发送礼物...'),
      });
      this.$http
          .post("/gift/sendGift", param)
          .then((res) => { this.handleSendResult(res); })
          .finally(() => { toast.clear(); });
    },

    sendBlastFun(item) {
      const param = { giftCode: item.code, liveId: this.live.id };
      const toast = Toast.loading({
        duration: 0, forbidClick: true,
        message: this.$i18n('sendingBlast', '霸屏发送中...'),
      });
      this.$http
          .post("/gift/sendScreenBlash", param)
          .then((res) => { this.handleSendResult(res); })
          .catch((err) => {this.$toast.fail(err.msg || '请求过于频繁，请稍后再试');})
          .finally(() => { toast.clear(); });
    },

    sendTextBlastFun() {
      if (!this.textBlastForm.content || !this.textBlastForm.content.trim()) {
        this.$toast(this.$i18n('enterBlastTextFirst', '请输入或生成霸屏文字'));
        return;
      }
      const param = { liveId: this.live.id, content: this.textBlastForm.content.trim() };
      const toast = Toast.loading({
        duration: 0, forbidClick: true,
        message: this.$i18n('sendingBlast', '霸屏发送中...'),
      });
      this.$http
          .post("/gift/sendTextBlast", param)
          .then((res) => { this.handleSendResult(res); })
          .catch((err) => {this.$toast.fail(err.msg || '请求过于频繁，请稍后再试');})
          .finally(() => { toast.clear(); });
    },

    sendPhotoBlastFun() {
      const urls = this.photoBlastList
          .filter(f => f.status === 'done' && f.url)
          .map(f => f.url);
      if (urls.length === 0) {
        this.$toast(this.$i18n('selectAtLeastOnePhoto', '请至少上传一张照片'));
        return;
      }
      if (this.photoBlastList.some(f => f.status === 'uploading')) {
        this.$toast(this.$i18n('photoUploading', '照片上传中，请稍候'));
        return;
      }
      const param = { liveId: this.live.id, photos: urls };
      const toast = Toast.loading({
        duration: 0, forbidClick: true,
        message: this.$i18n('sendingBlast', '霸屏发送中...'),
      });
      this.$http
          .post("/gift/sendPhotoBlast", param)
          .then((res) => { this.handleSendResult(res); })
          .catch((err) => {this.$toast.fail(err.msg || '请求过于频繁，请稍后再试');})
          .finally(() => { toast.clear(); });
    },

    handleSendResult(res) {
      if (res.data.isSend) {
        this.showGift = false;
        this.$Bus.$emit("refreshCoin");
        this.$toast.success(this.$i18n('sendSuccess', '发送成功！'));
        if (res.data.chatMsg) {
          this.$Bus.$emit("appendChatMsg", res.data.chatMsg);
        }
        this.textBlastForm.content = '';
        this.photoBlastList.forEach(p => p.previewUrl && URL.revokeObjectURL(p.previewUrl));
        this.photoBlastList = [];
      } else {
        this.$toast.fail({ message: this.$i18n('insufficientCoins', '金币不足，请稍等...') });
        this.$Bus.$emit("triggerOpenRecharge");
      }
    },

    openGift() {
      this.showGift = true;
    },
    getGiftList() {
      const toast = Toast.loading({
        duration: 0, forbidClick: true,
        message: this.$i18n('loadingGift', '礼物加载中...'),
      });
      this.$http
          .get("/gift/getGiftList", {
            params: { liveId: this.live.id, page: 1, size: 999 }
          })
          .then((res) => {
            this.giftList = (res.data || []).slice().sort((a, b) => (a.sort || 0) - (b.sort || 0));
          })
          .catch((err) => {
            console.error("礼物列表加载失败：", err);
            this.$toast.fail(err.msg || '礼物加载失败');
          })
          .finally(() => { toast.clear(); });
    },
  },
};
</script>

<style lang="less" scoped>
.sideBarContainer {
  position: fixed;
  right: 15px;
  bottom: 75px;
  display: flex;
  flex-direction: column;

  .popWrapper { width: 50px; }

  .BarItem {
    display: flex;
    width: 50px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    padding: 8px 5px;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-weight: 800;
    margin-bottom: 10px;
    border-radius: 10px;
    transition: all 0.2s ease;
    cursor: pointer;

    img { width: 32px; height: 32px; margin-bottom: 3px; }

    &:hover { border: 1px solid #666; transform: scale(1.05); }
  }
}

/* ═══════════════════════════════════════════
 * 原生弹窗：遮罩 + 底部面板 + 过渡动画
 * ═══════════════════════════════════════════ */
.nativePopupMask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.nativeGiftPopup {
  width: 100%;
  height: 55%;
  background: #262626;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 遮罩淡入淡出 */
.nativeFade-enter-active, .nativeFade-leave-active { transition: opacity 0.25s ease; }
.nativeFade-enter, .nativeFade-leave-to { opacity: 0; }

/* 面板上滑 */
.nativeSlideUp-enter-active { transition: transform 0.3s cubic-bezier(0.2, 0.8, 0.3, 1); }
.nativeSlideUp-enter { transform: translateY(100%); }

/* ═══════════════════════════════════════════
 * 原生页签头
 * ═══════════════════════════════════════════ */
.nativeTabsHead {
  position: relative;
  display: flex;
  flex-shrink: 0;
  height: 44px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  .nativeTab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    transition: color 0.2s;

    &.active { color: #28c76f; font-weight: bold; }
  }

  /* 底部滑动指示条：与页签同宽，translateX 平移 */
  .nativeTabLine {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 25%;  /* 4个页签，每个占25% */
    height: 2px;
    background: #28c76f;
    border-radius: 2px;
    transition: transform 0.25s ease;
  }
}

/* ═══════════════════════════════════════════
 * 原生横向轨道：scroll-snap 切页签
 * ═══════════════════════════════════════════ */
.nativeTabsTrack {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;

  /* 隐藏滚动条 */
  &::-webkit-scrollbar { display: none; }
  scrollbar-width: none;

  .nativePanel {
    flex: 0 0 100%;
    width: 100%;
    height: 100%;
    scroll-snap-align: start;
    overflow: hidden;
  }
}

/* ═══════════════════════════════════════════
 * 面板1/2：礼物网格 + 纵向滚动（核心！）
 * ═══════════════════════════════════════════ */
.giftListContainer {
  height: 100%;
  overflow-y: auto;                      // 上下滚动
  -webkit-overflow-scrolling: touch;     // iOS 惯性
  touch-action: pan-y;                   // 只放行纵向手势，横向留给轨道切页签
  overscroll-behavior-y: contain;        // 滚到头不穿透
  padding: 10px;
  box-sizing: border-box;

  /* 隐藏滚动条 */
  &::-webkit-scrollbar { display: none; }
  scrollbar-width: none;

  .giftListWrap {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    justify-content: start;
    align-items: start;
    gap: 10px;

    .giftItem {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 10px;

      .giftName {
        font-size: 10px;
        color: #fff;
        margin: 3px 0;
      }

      .price-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 3px;

        .gold-icon { width: 12px; height: 12px; margin-right: 2px; object-fit: contain; }
        .price-num { font-size: 7px; color: #28c76f; }
      }

      .sendGiftBt {
        display: none;
        text-align: center;
        width: 100%;
        height: 16px;
        line-height: 16px;
        font-size: 10px;
        border-radius: 0 0 9px 9px;
        color: #fff;
        background-color: #1fa861;
      }

      /* svga 封面 与 effect emoji 同一格子外观 */
      img,
      .giftIcon {
        width: 50px;
        height: 50px;
        border-radius: 5px;
        display: block;
        margin: 0 auto;
        border: 1px solid #333;
      }

      .giftIcon {
        font-size: 32px;
        line-height: 48px;
        text-align: center;
        background: rgba(255, 255, 255, 0.04);
      }

      /* 点击/触摸选中样式 */
      &:active {
        box-shadow: 0 0 0 2px #28c76f, 0 0 15px rgba(40, 199, 111, 0.7);
        background-color: rgba(40, 199, 111, 0.15);

        .sendGiftBt { display: block; }
      }
    }
  }
}

/* ═══════════════════════════════════════════
 * 面板3/4：表单
 * ═══════════════════════════════════════════ */
.blastFormContainer {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  overscroll-behavior-y: contain;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &::-webkit-scrollbar { display: none; }
  scrollbar-width: none;

  .nativeTextarea {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;
    resize: none;
    outline: none;
    font-family: inherit;

    &::placeholder { color: #666; }
  }

  .nativeWordLimit {
    text-align: right;
    font-size: 12px;
    color: #999;
    margin-top: -6px;
  }

  .blastBtnWrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;

    .blastPriceTip { margin-right: auto; font-size: 12px; color: #28c76f; }
  }

  .nativeBtn {
    padding: 8px 16px;
    font-size: 13px;
    border-radius: 6px;
    border: 1px solid #28c76f;
    background: transparent;
    color: #28c76f;
    cursor: pointer;

    &.solid { background: #28c76f; color: #fff; }
    &.ghost:disabled { opacity: 0.5; }
    &:active { opacity: 0.8; }
  }
}

/* ═══════════════════════════════════════════
 * 面板4：原生照片上传网格
 * ═══════════════════════════════════════════ */
.nativeUploadGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;

  .nativeUploadCell {
    position: relative;
    aspect-ratio: 1;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid #333;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .nativeUploadStatus {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 11px;

      &.fail { background: rgba(255, 77, 79, 0.6); }
    }

    .nativeUploadDel {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      border-radius: 50%;
      font-size: 14px;
      cursor: pointer;
    }

    &.add {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      color: #666;
      border: 1px dashed #444;
      cursor: pointer;

      &:active { background: rgba(40, 199, 111, 0.1); }
    }
  }
}

/* ═══════════════════════════════════════════
 * 以下原样保留：抽奖 / 核销 / 奖品列表样式
 * ═══════════════════════════════════════════ */
.draw-popup {
  background: rgba(30, 27, 75, 0.95) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5) !important;
  overflow: visible !important;
  z-index: 9999 !important;
}

.lotteryContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;

  .qrCodeImg { width: 250px; height: 250px; border: 5px solid #fff; border-radius: 10px; }
  .tip { font-size: 13px; margin-top: 5px; color: #fff; }
}

.prizeItem {
  position: relative;
  border-radius: 10px;
  margin: 15px;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #28c76f;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .mainWrap {
    display: flex;
    align-items: center;

    img { width: 90px; height: 90px; border-radius: 5px; object-fit: cover; }

    .infoWrap {
      padding: 10px;
      margin-left: 15px;

      .title { font-size: 23px; color: #333; font-weight: bold; }
    }
  }

  .slaveWrap {
    margin-top: 5px;
    padding-top: 5px;
    border-top: 1px dashed #eee;

    .left {
      font-size: 13px;
      color: #666;

      .prizeName { font-size: 12px; color: #ff4d4f; margin-right: 10px; }
    }
  }

  .statusWrap {
    position: absolute;
    width: 70px;
    height: 70px;
    bottom: 10px;
    right: 15px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .btWrap {
    position: absolute;
    width: 80px;
    height: 30px;
    bottom: 20px;
    right: 25px;
    background-color: #28c76f;
    color: #fff;
    text-align: center;
    line-height: 30px;
    font-size: small;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover { background-color: #1fa861; transform: scale(1.05); }
  }
}
</style>
